import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DialogService } from 'primeng/dynamicdialog';
import { BackButtonComponent } from '@app/shared/components/back-button/back-button.component';
import { ButtonModule } from 'primeng/button';
import { TabsModule } from 'primeng/tabs';
import { SearchBarComponent } from '@app/shared/components/search-bar/search-bar.component';
import { ListarBolseirosComponent } from '../listar-bolseiros/listar-bolseiros.component';
import { ListarInstituicoesEnsinoComponent } from '../listar-instituicoes-ensino/listar-instituicoes-ensino.component';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import {
  PaisService,
  ProvinciaService,
  MunicipioService,
  CommunicationService,
  BolseiroService,
  UtilizadorService,
  BolsaService,
} from '../../api/services';
import { ApiService } from '@core/providers/http';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { CadastrarBolseirosComponent } from '../../bolseiros/cadastrar-bolseiros/cadastrar-bolseiros.component';
import { ToastModule } from 'primeng/toast';
import { Bolseiro } from '../../api/models/bolseiro.model';

@Component({
  standalone: true,
  selector: 'app-detalhe-bolsa',
  imports: [
    CommonModule,
    BackButtonComponent,
    ButtonModule,
    TabsModule,
    SearchBarComponent,
    ListarBolseirosComponent,
    ListarInstituicoesEnsinoComponent,
    ToastModule,
    AvatarModule,
    AvatarGroupModule,
  ],
  providers: [
    DialogService,
    ApiService,
    PaisService,
    ProvinciaService,
    MunicipioService,
    CommunicationService,
    BolseiroService,
    UtilizadorService,
    BolsaService,
    MessageService,
  ],
  templateUrl: './detalhe-bolsa.component.html',
  styleUrls: ['./detalhe-bolsa.component.scss'],
})
export class DetalheBolsaComponent implements OnInit {
  dialogService = inject(DialogService);
  paisService = inject(PaisService);
  provinciaService = inject(ProvinciaService);
  municipioService = inject(MunicipioService);
  communicationService = inject(CommunicationService);
  bolseiroService = inject(BolseiroService);
  utilizadorService = inject(UtilizadorService);
  messageService = inject(MessageService);
  bolsaService = inject(BolsaService);
  route = inject(ActivatedRoute);
  bolsaID!: string;
  isLoading: boolean = false;

  bolsa: any = null; // Definindo a variável bolsa
  countries: any[] = [];
  provinces: any[] = [];
  municipalities: any[] = [];
  bolseiros: any[] = [];
  utilizadores: any[] = [];
  private subscriptions = new Subscription();

  estados = [
    { id: 'ativo', designacao: 'Activo' },
    { id: 'inativo', designacao: 'Inactivo' },
  ];

  tiposDeBolsa = [
    { id: 'parcial', designacao: 'Parcial' },
    { id: 'integral', designacao: 'Integral' },
  ];

  nacionalidades = [
    { label: 'Angola', id: 1 },
    { label: 'Namibiana', id: 2 },
  ];

  estadoCivilOptions = [
    { label: 'Solteiro', id: 1 },
    { label: 'Casado', id: 2 },
  ];

  generoOptions = [
    { label: 'Masculino', id: 1 },
    { label: 'Feminino', id: 2 },
  ];

  nivelAcademicoOptions = [
    { label: 'Base', id: 1 },
    { label: 'Médio', id: 2 },
    { label: 'Licenciado', id: 3 },
  ];

  provincias = [
    { label: 'Luanda', id: 1 },
    { label: 'Benguela', id: 2 },
    { label: 'Huambo', id: 3 },
  ];

  municipios = [
    { label: 'Cazenga', id: 1 },
    { label: 'Viana', id: 2 },
    { label: 'Cacuaco', id: 3 },
  ];

  universityName = 'Bolsa de Mérito Académico para Mulheres';
  totalRecords = 0;
  page = 1;
  rows = 10;

  constructor() {
    this.loadCountries();
  }

  ngOnInit(): void {
    this.bolsaID = this.route.snapshot.paramMap.get('id')!;
    this.getBolsaDetails(this.bolsaID);
    this.getAllBolseiros();
    // this.getAllUtilizadores();
    this.subscriptions.add(
      this.communicationService.countryChanged$.subscribe(
        (country: string | null) => {
          if (country) {
            this.loadProvinces(country);
          }
        }
      )
    );

    this.subscriptions.add(
      this.communicationService.provinceChanged$.subscribe(
        (province: string | null) => {
          if (province) {
            this.loadMunicipalities(province);
          }
        }
      )
    );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  loadCountries() {
    this.paisService.list().subscribe((countries) => {
      this.countries = countries;
    });
  }

  loadProvinces(country: string) {
    this.provinciaService.list(country).subscribe((provinces) => {
      this.provinces = provinces;
      this.communicationService.updateProvinces(provinces);
      this.municipalities = []; // Reset municipalities when country changes
    });
  }

  loadMunicipalities(province: string) {
    this.municipioService.list(province).subscribe((municipalities) => {
      this.municipalities = municipalities;
      this.communicationService.updateMunicipalities(municipalities);
    });
  }

  getAllUtilizadores() {
    this.isLoading = true; // Iniciar carregamento
    this.utilizadorService.list().subscribe(
      (data) => {
        this.utilizadores = data;
        this.isLoading = false; // Parar carregamento
      },
      (error) => {
        console.error('Erro ao buscar utilizadores:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao buscar utilizadores.',
        });
        this.isLoading = false; // Parar carregamento
      }
    );
  }

  getAllBolseiros(queryParams?: any) {
    this.isLoading = true; // Iniciar carregamento
    this.bolseiroService.list({ ...queryParams, page: this.page, rows: this.rows }).subscribe(
      (response: { data: Bolseiro[], totalRecords: number }) => {
        this.bolseiros = response.data;
        this.totalRecords = response.totalRecords;
        this.isLoading = false; // Parar carregamento
      },
      (error: any) => {
        console.error('Erro ao buscar bolseiros:', error);
        this.isLoading = false; // Parar carregamento
      }
    );
  }

  getBolsaDetails(bolsaID: string) {
    this.bolsaService.show(bolsaID).subscribe(
      ({ data }: any) => {
        this.bolsa = data;
      },
      (error: any) => {
        console.error('Erro ao buscar detalhes da bolsa:', error);
      }
    );
  }

  toggleBolsaStatus() {
    this.bolsaService.toggleStatus(this.bolsaID).subscribe(
      (isActive) => {
        // this.bolsa.isActive = isActive;
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: `Estado da bolsa alterado com sucesso!`,
        });
        this.getBolsaDetails(this.bolsaID);
      },
      (error) => {
        console.error('Erro ao alterar status da bolsa:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao alterar status da bolsa.',
        });
      }
    );
  }

  showDialog() {
    const ref = this.dialogService.open(CadastrarBolseirosComponent, {
      showHeader: false,
      width: '50%',
      modal: true,
      data: {
        utilizadores: this.utilizadores,
        nacionalidades: this.nacionalidades,
        estadoCivilOptions: this.estadoCivilOptions,
        generoOptions: this.generoOptions,
        nivelAcademicoOptions: this.nivelAcademicoOptions,
        provincias: this.provincias,
        municipios: this.municipios,
        tiposDeBolsa: this.tiposDeBolsa,
        estados: this.estados,
        bolseiros: this.bolseiros,
        provinces: this.provinces,
        municipalities: this.municipalities,
        countries: this.countries,
      },
    });

    ref.onClose.subscribe((data) => {
      if (data) {
        this.storeBolseiro(data);
      }
    });
  }

  storeBolseiro(data: any) {
    this.isLoading = true; // Iniciar carregamento
    this.bolseiroService.store(data).subscribe(
      () => {
        this.isLoading = false; // Parar carregamento
        this.getAllBolseiros();
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Bolseiro criado com sucesso!',
        });
      },
      (error) => {
        console.error('Erro ao criar bolseiro:', error);
        this.isLoading = false; // Parar carregamento
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao criar bolseiro.',
        });
      }
    );
  }
}
